import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputSelect from '../../commons/form/InputSelect'
import InputCheckBox from '../../commons/form/InputCheckBox'
import DossierStageModal from '../../../containers/masters/DossierStage/DossierStageModalPage'
import MapSectionsMasters from '../../../util/map-sections-masters'

class DossierStage extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        dossierSubTypeId: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.initializeFilterState()
    this.props.actions.fetchDossierStageList()
    this.props.actions.fetchSearchDossierSubType()
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (this.props.filter.dossierSubTypeId !== nextProps.filter.dossierSubTypeId && nextProps.filter.dossierSubTypeId === null) {
      this.props.initialize({})
      this.setState({ filter: { ...nextProps.filter } })
    }
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchDossierStageList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchDossierStageList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleDossierSubTypeChange (dossierSubTypeId) {
    if (this.state.filter?.dossierSubTypeId !== dossierSubTypeId) {
      this.setState({ filter: { ...this.state.filter, dossierSubTypeId } }, () => this.searchDossierStages())
    }
  }

  searchDossierStages () {
    this.props.actions.fetchDossierStageList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  render () {
    const {
      t, dossierStageList,
      pagesCount, dossierStageCount, filter,
      filter: { page },
      actions: {
        openEditDossierStageModal
      }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'dossierStageMasterPage' })
    const tKey = 'MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)

    return (
      <div id='dossierStageMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.dossierSubTypeId"
                controlLabel={t(`${tKey}DOSSIER_STAGES_MASTERS.DOSSIER_SUB_TYPE`)}
                placeholder={t(`${tKey}DOSSIER_STAGES_MASTERS.DOSSIER_SUB_TYPE`)}
                multi={false}
                valueKey="id"
                labelKey="value"
                childrenKey="children"
                options={this.props.combos.searchDossierSubtypesCombo}
                onChange={(value) => this.handleDossierSubTypeChange(value)}
              />
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer' + (this.state.maxiTable ? ' maxiTable' : '')}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {(dossierStageList.length !== 0) &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('name') }}>
                        {t(`${tKey}DOSSIER_STAGES_MASTERS.NAME`)}
                        <i className={this.getSortIcon('name')} />
                      </th>
                      <th class="actions" onClick={() => { this.changeOrder('MaxDays') }}>
                        {t(`${tKey}DOSSIER_STAGES_MASTERS.MAX_DAYS`)}
                        <i className={this.getSortIcon('MaxDays')} />
                      </th>
                      <th class="actions" onClick={() => { this.changeOrder('PercentToWarn') }}>
                        {t(`${tKey}DOSSIER_STAGES_MASTERS.WARNING_PERCENTAGE`)}
                        <i className={this.getSortIcon('PercentToWarn')} />
                      </th>
                      <th onClick={() => { this.changeOrder('PermissionToNotification') }}>
                        {t(`${tKey}DOSSIER_STAGES_MASTERS.NOTIFY_PERMISSION`)}
                        <i className={this.getSortIcon('PermissionToNotification')} />
                      </th>
                      <th onClick={() => { this.changeOrder('PermissionResponsable') }}>
                        {t(`${tKey}DOSSIER_STAGES_MASTERS.MANAGER_PERMISSION`)}
                        <i className={this.getSortIcon('PermissionResponsable')} />
                      </th>
                      <th class="actions" onClick={() => { this.changeOrder('VisibleToProcessingAgency') }}>
                        {t(`${tKey}DOSSIER_STAGES_MASTERS.VISIBLE_PROCESSING_AGENCY`)}
                        <i className={this.getSortIcon('VisibleToProcessingAgency')} />
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dossierStageList && dossierStageList.map((dossierStage, idx) => (
                      <tr key={idx} className={dossierStage.isDeleted ? 'is-deleted' : ''}>
                        <td>{dossierStage.name}</td>
                        <td className='actions'>{dossierStage.maxDays}</td>
                        <td className='actions'>{dossierStage.percentToWarn}</td>
                        <td>{dossierStage.permissionToNotification}</td>
                        <td>{dossierStage.permissionResponsable}</td>
                        <td className='actions'>{
                          <Field
                            component={InputCheckBox}
                            colWidth={100} // 25, 33, 50, 75, 100 default=25
                            name={'selectedCheck_' + dossierStage.dossierStageId}
                            checked = {dossierStage.visibleToProcessingAgency}
                            disabled= {true}
                            id={'selectedCheck_' + dossierStage.dossierStageId}
                          />}
                        </td>
                        <td className='actions'>
                          <div>
                            <OverlayTrigger placement="left" overlay={editTooltip}>
                              <a className='_Btn accept stk o-icn ' onClick={() => openEditDossierStageModal(dossierStage.dossierStageId)}>
                                <i className="iDocIcon-edit" />
                              </a>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    ))
                    }

                  </tbody>
                </Table>
              }
              {(dossierStageList === null || dossierStageList === undefined || dossierStageList.length === 0) &&
                <p className="no_results" >{t(`${tKey}DOSSIER_STAGES_MASTERS.RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={dossierStageCount}
                    onSelectAction={(value) =>
                      this.props.actions.fetchDossierStageList({ ...filter, ...this.state.filter, page: value })
                    }
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <DossierStageModal/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listDossierStage'
})(DossierStage)
